<!-- ワンストップガイド -->
<template>
  <div>
    <header-component />
  </div>
  <loading-overlay v-model:active="isLoading" :is-full-page="true" />
  <div v-if="isInitError" id="com_form_contet1">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="apiErrorMessage" class="error-message">
        {{ apiErrorMessage }}
      </div>
    </div>
  </div>
  <div v-else>
    <div v-if="isDataFetched" class="com_page_title1">
      <div class="com_inner1 clearfix">
        <div class="block1">
          <img
            src="@/assets/common/img/onestop-guide-title-img1.png"
            alt=""
            class="image1"
          />
        </div>
      </div>
    </div>
    <!-- エラーメッセージの表示エリア -->
    <div v-if="errorMessage" class="com_inner1 clearfix">
      <div class="error-message">
        {{ errorMessage }}
      </div>
    </div>
    <div v-if="isDataFetched" id="contents3">
      <section class="com_sec1">
        <div class="com_inner1 clearfix">
          <div class="com_contents3">
            <div class="main_column2">
              <div v-if="!isSerched">
                <div class="com_d_content2">
                  <div
                    v-for="item in filteredCategoryListData"
                    :key="item.categoryId"
                    :class="{ disabled: isProcessing }"
                  >
                    <div class="com_i_title1">
                      <div>
                        <img
                          :src="getImageUrl(item.imgFileName)"
                          alt=""
                          class="icon-c-doc1"
                        />
                        <h2>{{ item.categoryName }}</h2>
                      </div>
                      <div>
                        <a
                          href="#"
                          class="com_sr_button1"
                          @click.prevent="
                            getNarrowCategoryData(
                              item.categoryId,
                              item.categoryName
                            )
                          "
                        >
                          <span class="text">
                            <span class="text__item">すべて表示</span>
                            <span class="text__item" aria-hidden="true"
                              >すべて表示</span
                            >
                          </span>
                        </a>
                      </div>
                    </div>
                    <div class="com_topic_list2">
                      <div
                        v-for="contents in getContentsByCategory(
                          item.categoryId,
                          item.dispCount
                        )"
                        :key="contents.contentId"
                      >
                        <div class="body1">
                          <router-link
                            :to="`/${contents.detailPath}/categoryId/${contents.categoryId}/contentsId/${contents.contentId}`"
                            class="com_link1"
                            >{{ contents.contentsTitle }}</router-link
                          >
                        </div>
                        <div v-if="contents.fileFlg" class="buttons1">
                          <a
                            href="#"
                            class="com_dl_button2"
                            @click.prevent="
                              downloadFiles(
                                contents.categoryId,
                                contents.contentId,
                                ''
                              )
                            "
                            ><span>ダウンロード</span></a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 絞込検索後エリア -->
              <div v-else>
                <div class="com_search_result_hd1">
                  <div>
                    <p class="text1">
                      <span>{{ dispKeyWord }}</span
                      >{{ dispTitle }}
                    </p>
                  </div>
                  <div>
                    <dl class="com_sort_list1">
                      <dt><span class="com_icon_sort1"></span>並び替え：</dt>
                      <dd>
                        <span class="selected1">{{
                          currentSortOptionLabel
                        }}</span>
                        <ul class="list1">
                          <li>
                            <a href="#" @click.prevent="updateSortOption('new')"
                              >新着順</a
                            >
                          </li>
                          <li>
                            <a
                              href="#"
                              @click.prevent="updateSortOption('category')"
                              >カテゴリ順</a
                            >
                          </li>
                          <li>
                            <a
                              href="#"
                              @click.prevent="updateSortOption('recommend')"
                              >おすすめ順</a
                            >
                          </li>
                        </ul>
                      </dd>
                    </dl>
                  </div>
                </div>
                <div class="com_topic_list2">
                  <div
                    v-for="item in paginatedData"
                    :key="item.contentId"
                    :class="{ disabled: isProcessing }"
                  >
                    <div class="meta1">
                      <span class="date1 roboto">{{ item.postPeriod }}</span
                      ><span class="com_tag2">{{ item.subCategoryName }}</span>
                    </div>
                    <div class="body1">
                      <router-link
                        :to="`/${item.detailPath}/categoryId/${item.categoryId}/contentsId/${item.contentId}`"
                        class="com_link1"
                        @click="handleContentsLinkClick"
                        >{{ item.contentsTitle }}</router-link
                      ><span v-if="item.newFlg" class="com_icon_new">NEW</span>
                    </div>
                    <div v-if="item.fileFlg" class="buttons1">
                      <a
                        href="#"
                        class="com_dl_button2"
                        @click.prevent="
                          downloadFiles(item.categoryId, item.contentId, '')
                        "
                      >
                        <span>ダウンロード</span>
                      </a>
                    </div>
                    <div v-if="isKaunetAdmin" class="edit1">
                      <a
                        href="#"
                        @click.prevent="
                          editContents(item.categoryId, item.contentId)
                        "
                        class="com_edit1"
                        ><span></span
                      ></a>
                    </div>
                  </div>
                </div>
                <content-pagination
                  :current-page="currentPage"
                  :total-pages="totalPages"
                  :items-per-page="itemsPerPage"
                  @page-changed="handlePageChange"
                />
              </div>
            </div>

            <div class="side_search_option1">
              <div v-if="isSerched">
                <button type="button" class="button1" @click="backInitDisp">
                  初期表示に戻す
                </button>
                <hr />
              </div>

              <h2 class="title1">
                <span class="com_icon_option1"></span>絞り込み検索
              </h2>

              <div class="block_search1">
                <h3 class="title2">キーワードから探す</h3>
                <div>
                  <input
                    type="text"
                    name=""
                    placeholder="キーワードを入力"
                    @keyup.enter="narrowSearch"
                    v-model="narrowKeyword"
                    maxlength="50"
                  />
                  <button type="button" name="" @click="narrowSearch"></button>
                </div>
              </div>
              <div class="block_options_group1">
                <div class="com_center1 com_mgb10">
                  <a
                    href="javascript:void(0)"
                    class="option_uncheck_all1 com_link1"
                    @click="uncheckAll"
                  >
                    <span class="com_icon_cross1"></span>チェックを外す
                  </a>
                </div>
                <h3 class="title2">カテゴリーから探す</h3>
                <div
                  v-for="(group, index) in groupedTags"
                  :key="index"
                  class="option_group1"
                >
                  <div class="hd1">
                    <label class="com_checkbox1">
                      <input
                        type="checkbox"
                        v-model="group.isCategoryChecked"
                        @change="toggleCategory(group)"
                      />
                      <span class="t1">{{ group.categoryName }}</span>
                    </label>
                  </div>
                  <div class="body1">
                    <label
                      v-for="(tag, idx) in group.tags"
                      :key="idx"
                      class="com_checkbox1"
                    >
                      <input
                        type="checkbox"
                        v-model="tag.isChecked"
                        @change="checkCategoryStatus(group, tag)"
                      />
                      <span class="t2">{{ tag.tagName }}</span>
                    </label>
                  </div>
                </div>
                <hr />
                <button type="button" class="button1" @click="narrowSearch">
                  検索
                </button>
                <div class="com_center1 com_mgt5">
                  <a
                    href="javascript:void(0)"
                    class="option_uncheck_all1 com_link1"
                    @click="uncheckAll"
                  >
                    <span class="com_icon_cross1"></span>チェックを外す
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop />
</template>
<script lang="ts">
import { AxiosError } from "axios";
import { defineComponent, onMounted, ref, computed, isShallow } from "vue";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import {
  formatMessage,
  outputDebugLogs,
  sanitizeInput,
  getTargetDate,
  scrollToTop,
  isTokenAlive,
  trimKeyword,
} from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import apiAuthClient from "@/util/apiClientAuth";
import apiDownloadClient from "@/util/apiClientDownload";
import { useProcessingStore } from "../../store/useProcessingStore";
import messages from "@/assets/messages.json";
import BackToTop from "../controls/BackToTop.vue";
import { useUserStore } from "@/store/userStore";
import { useRouter } from "vue-router";
import ContentPagination from "../controls/ContentPagination.vue";
import LoadingOverlay from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

interface ContentsItem {
  categoryId: string;
  categoryName: string;
  subCategoryName: string;
  contentId: string;
  postPeriod: string;
  contentsTitle: string;
  imptFlg: boolean;
  newFlg: boolean;
  fileFlg: boolean;
  serchScore: number;
  detailPath: string;
  updateFormPath: string;
}

interface CategoryItem {
  categoryId: string;
  categoryName: string;
  imgFileName: string;
  sortNo: string;
  dispCount: number;
  categoryUrl: string;
}

interface TagItem {
  categoryId: string;
  categoryName: string;
  tagId: string;
  tagName: string;
  isChecked: boolean;
}

interface CategoryGroup {
  categoryId: string;
  categoryName: string;
  tags: TagItem[];
  isCategoryChecked: boolean;
}

export default defineComponent({
  name: "OneStopGideTopComponent",
  components: {
    HeaderComponent,
    FooterComponent,
    BackToTop,
    ContentPagination,
    LoadingOverlay,
  },
  setup() {
    const router = useRouter();
    const errorMessage = ref(""); // エラーメッセージ（キーワード検索の下のやつ）
    const apiErrorMessage = ref(""); // エラーメッセージ（ページの真ん中にでるやつ）
    const isInitError = ref(false); // 初期表示時のエラーフラグ
    const processingStore = useProcessingStore(); //状態管理ストア
    const narrowKeyword = ref(""); // 絞込キーワード
    const agCode = ref(""); // AGコード
    const userId = ref(""); // ユーザーID
    const pseudoAgCode = ref(""); // 疑似ログインAGコード
    const pseudoUserId = ref(""); // 疑似ログインユーザーID
    const serchAgCode = ref(""); // 検索用AGコード
    const serchUserId = ref(""); // 検索用ユーザーID
    const tagListData = ref<TagItem[]>([]); // タグデータ
    const contentsListData = ref<ContentsItem[]>([]); // コンテンツ一覧データ
    const oneStopGideListData = ref<ContentsItem[]>([]); // ワンストップガイドトップデータ
    const narrowContentsListData = ref<ContentsItem[]>([]); // 絞込コンテンツ一覧データ
    const categoryListData = ref<CategoryItem[]>([]); // カテゴリ一覧データ
    const { logoutUser } = useUserStore();
    const isSerched = ref(false); // 絞込済かのフラグ
    const dispTitle = ref(""); // 表示タイトル
    const dispKeyWord = ref(""); // 表示切キーワード
    const currentPage = ref(1); // 現在ページ
    const itemsPerPage = ref(20); // 1ページに表示する最大件数
    const isKaunetAdmin = ref(false); // カウネット管理者フラグ
    const selectedCategoryId = ref(""); // 選択したカテゴリID
    const sortOption = ref("recommend"); // 初期値は "おすすめ順"
    const isDataFetched = ref(false); // データが取得済みかどうかを追跡
    const isLoading = ref(false);

    // 初期処理
    onMounted(async () => {
      isLoading.value = true;
      try {
        // ローカルストレージからユーザー情報を取得して内部変数に展開
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          agCode.value = parsedUserInfo.agCode;
          userId.value = parsedUserInfo.userId;
          pseudoAgCode.value = parsedUserInfo.pseudoAgCode;
          pseudoUserId.value = parsedUserInfo.pseudoUserId;
          isKaunetAdmin.value =
            parsedUserInfo.isKaunet && parsedUserInfo.isAdmin;

          if (pseudoUserId.value == "") {
            // 疑似ログインIDが空の場合は、疑似ログインしていないとみなす
            serchUserId.value = userId.value;
            serchAgCode.value = agCode.value;
          } else {
            outputDebugLogs("疑似ログイン状態");
            serchUserId.value = pseudoUserId.value;
            serchAgCode.value = pseudoAgCode.value;
          }

          outputDebugLogs("管理者フラグ：" + parsedUserInfo.isKaunet);
          outputDebugLogs("カウネットフラグ：" + parsedUserInfo.isAdmin);
        }

        // コンテンツ一覧取得API
        const response = await apiAuthClient.post(
          "/api/OneStopGide/getOneStopGideList",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            targetDate: getTargetDate(""),
          }
        );

        // レスポンスからカテゴリ一覧を取得
        categoryListData.value = response.data.categoryListData;

        // レスポンスからコンテンツ一覧を取得
        contentsListData.value = response.data.containtsListData;

        // レスポンスからワンストップガイドトップ表示データを取得
        oneStopGideListData.value = response.data.oneStopGideListData;

        // レスポンスからタグ一覧を取得
        tagListData.value = response.data.tagListData;

        isInitError.value = false;
        isSerched.value = false;
        isDataFetched.value = true;

        scrollToTop();
      } catch (error: unknown) {
        // エラー時は初期表示エラーフラグをON
        isInitError.value = true;
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          switch (axiosError.response.status) {
            case 416:
              // 取得件数オーバー
              apiErrorMessage.value = formatMessage(
                messages.ERR_0023,
                "サイト内検索"
              );
              break;
            default:
              // その他のエラー
              apiErrorMessage.value = messages.ERR_SYS999;
          }
        } else if (axiosError.request) {
          apiErrorMessage.value = messages.ERR_SYS001;
        } else {
          apiErrorMessage.value = messages.ERR_SYS002;
          if (process.env.VUE_APP_DEBUG === "true") {
            console.log("Error: ", axiosError.message);
          }
        }
      } finally {
        isLoading.value = false;
      }
    });

    //** 選択されているカテゴリIDをカンマ区切りで取得します */
    const selectedCategoryIds = computed(() => {
      return groupedTags.value
        .filter((group) => group.isCategoryChecked)
        .map((group) => group.categoryId)
        .join(",");
    });

    //** 選択されているタグIDをカンマ区切りで取得します */
    const selectedTagIds = computed(() => {
      return groupedTags.value
        .flatMap((group) => group.tags)
        .filter((tag) => tag.isChecked)
        .map((tag) => tag.tagId)
        .join(",");
    });

    /**
     * カテゴリIDをカンマ区切りで結合します
     */
    const categoryIdsString = computed(() => {
      return categoryListData.value.map((group) => group.categoryId).join(",");
    });

    /**
     * 絞込検索実行
     */
    const narrowSearch = async () => {
      // なにか処理中の場合は何もしない
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;

      try {
        // ------- for debug --------
        outputDebugLogs("絞込検索");
        outputDebugLogs("キーワード：" + narrowKeyword.value);
        outputDebugLogs("絞込カテゴリ：" + selectedCategoryIds.value);
        outputDebugLogs("絞込タグ：" + selectedTagIds.value);
        // ------- for debug --------

        // エラーメッセージを初期化
        errorMessage.value = "";
        apiErrorMessage.value = "";

        // キーワードをサニタイジング
        const sanitizedKeyWord = trimKeyword(
          sanitizeInput(narrowKeyword.value, true)
        );

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // 1文字の場合はNG
        if (sanitizedKeyWord.length == 1) {
          errorMessage.value = formatMessage(
            messages.ERR_0028,
            "キーワード",
            "2"
          );
          return;
        }

        // コンテンツ一覧取得API
        const response = await apiAuthClient.post(
          "/api/SiteSearch/getContentsList",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            keyword: "",
            categoryId: "",
            narrowKeyword: sanitizedKeyWord,
            narrowCategorys:
              selectedCategoryId.value || categoryIdsString.value,
            narrowTags: selectedTagIds.value,
            postPeriodFrom: "",
            postPeriodTo: "",
            isOutsidePostPeriod: false,
            targetDate: getTargetDate(""),
            isNarrowCategory: true,
          }
        );

        // レスポンスからコンテンツリストを取得
        narrowContentsListData.value = response.data.containtsListData;

        // ページネーションの現在ページを1ページ目に
        currentPage.value = 1;

        if (sanitizedKeyWord) {
          dispKeyWord.value = "「" + sanitizedKeyWord + "」";
          dispTitle.value =
            "の検索結果:" + narrowContentsListData.value.length + "件";
        } else {
          dispKeyWord.value = "";
          dispTitle.value =
            "検索結果:" + narrowContentsListData.value.length + "件";
        }

        isSerched.value = true;
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          switch (axiosError.response.status) {
            case 416:
              // 検索件数オーバー
              errorMessage.value = formatMessage(
                messages.ERR_0023,
                "サイト内検索"
              );
              break;
            default:
              // ほかのエラー
              errorMessage.value = messages.ERR_SYS999;
          }
        } else if (axiosError.request) {
          errorMessage.value = messages.ERR_SYS001;
        } else {
          errorMessage.value = messages.ERR_SYS002;
          if (process.env.VUE_APP_DEBUG === "true") {
            console.log("Error: ", axiosError.message);
          }
        }
      } finally {
        // スクロールを一番上に戻す
        scrollToTop();
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    };

    //** カテゴリIDでグループ化したタグのリスト */
    const groupedTags = computed(() => {
      const groups: CategoryGroup[] = [];
      const categoryMap: Record<string, CategoryGroup> = {};

      tagListData.value.forEach((item) => {
        if (
          selectedCategoryId.value &&
          selectedCategoryId.value !== item.categoryId
        ) {
          return;
        }
        if (!categoryMap[item.categoryId]) {
          categoryMap[item.categoryId] = {
            categoryId: item.categoryId,
            categoryName: item.categoryName,
            tags: [],
            isCategoryChecked: false,
          };
          groups.push(categoryMap[item.categoryId]);
        }
        categoryMap[item.categoryId].tags.push(item);
      });

      // Set initial category checked status based on tags
      groups.forEach((group) => {
        group.isCategoryChecked = group.tags.every((tag) => tag.isChecked);
      });

      return groups;
    });

    //** カテゴリIDのチェックON・OFFで紐づいているタグのチェックをON・OFFする */
    const toggleCategory = (group: CategoryGroup) => {
      group.tags.forEach((tag) => {
        tag.isChecked = group.isCategoryChecked;
        toggleTag(tag);
      });
    };

    //** 同じタグIDのチェック状態を更新する */
    const toggleTag = (tag: TagItem) => {
      tagListData.value.forEach((item) => {
        if (item.tagId === tag.tagId) {
          item.isChecked = tag.isChecked;
        }
      });
    };

    //** カテゴリのチェック状態 */
    const checkCategoryStatus = (group: CategoryGroup, tag: TagItem) => {
      group.isCategoryChecked = group.tags.every((tag) => tag.isChecked);
      toggleTag(tag);
    };

    //** すべてのタグの選択状態を解除します */
    const uncheckAll = () => {
      groupedTags.value.forEach((group) => {
        group.isCategoryChecked = false;
        group.tags.forEach((tag) => {
          tag.isChecked = false;
        });
      });
    };

    const getImageUrl = (imgFileName: string) => {
      try {
        return require(`@/assets/common/img/${imgFileName}`);
      } catch (e) {
        console.error(`Failed to load image: ${imgFileName}`, e);
        return "";
      }
    };

    /**  指定したカテゴリIDのデータを取得します
     * @param categoryId - カテゴリID
     * @param count - 取得する件数
     */
    const getContentsByCategory = (
      categoryId: string,
      count: number
    ): ContentsItem[] => {
      return oneStopGideListData.value
        .filter((item) => item.categoryId === categoryId)
        .slice(0, count);
    };

    /**
     * カテゴリIDに該当するデータが存在するかのチェック
     * @param categoryId = カテゴリID
     */
    const isExistsCategoryData = (categoryId: string) => {
      if (
        oneStopGideListData.value.filter(
          (item) => item.categoryId === categoryId
        ).length > 0
      ) {
        return true;
      } else {
        return false;
      }
    };

    /**
     * isExistsCategoryData でTrueのcategoryListDataだけを抽出します
     */
    const filteredCategoryListData = computed(() => {
      return categoryListData.value.filter((category) =>
        isExistsCategoryData(category.categoryId)
      );
    });

    /**
     * ファイルダウンロード
     * @param ctgyId - カテゴリID
     * @param ctsId - コンテンツID
     */
    const downloadFiles = async (
      ctgyId: string,
      ctsId: string,
      flName: string
    ) => {
      // 何か処理中の場合は処理しない
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // エラーメッセージ初期化
        errorMessage.value = "";

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // ファイルダウンロードAPI
        const response = await apiDownloadClient.post("/api/download", {
          systemKbn: AppConstants.SYSTEM_KBN_WITH,
          userId: userId.value,
          agCode: agCode.value,
          categoryId: ctgyId,
          contentId: ctsId,
          fileName: flName,
          targetDate: getTargetDate(""),
          pseudoUserId: pseudoUserId.value,
          pseudoAgCode: pseudoAgCode.value,
          screenName: "コンテンツ詳細",
        });

        // Content-Dispositionヘッダーからファイル名を取得
        const contentDisposition = response.headers["content-disposition"];
        let fileName = "downloaded_file";
        if (contentDisposition) {
          const match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
          if (match && match[1]) {
            fileName = decodeURIComponent(match[1]);
          }
        }

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        // ダウンロードAPIエラー
        outputDebugLogs("Error downloading files: " + error);

        // エラーメッセージを表示
        errorMessage.value = formatMessage(
          messages.ERR_SYS003,
          "ファイルダウンロード"
        );

        // スクロールを一番上に戻す
        scrollToTop();
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    //** 初期状態に戻す */
    const backInitDisp = async () => {
      // なにか処理中の場合は何もしない
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        selectedCategoryId.value = "";

        // 絞込キーワードをクリア
        narrowKeyword.value = "";
        // タグの選択状態を解除
        uncheckAll();

        isSerched.value = false;

        // ページネーションの現在ページを1ページ目に
        currentPage.value = 1;
      } finally {
        // スクロールを一番上に戻す
        scrollToTop();
        processingStore.isProcessing = false;
      }
    };

    //** ページネーションのデータ生成 */
    const paginatedData = computed(() => {
      const start = (currentPage.value - 1) * itemsPerPage.value;
      const end = start + itemsPerPage.value;
      return sortedContentsListData.value.slice(start, end);
    });

    //** 頁総数を取得 */
    const totalPages = computed(() => {
      return Math.ceil(
        narrowContentsListData.value.length / itemsPerPage.value
      );
    });

    //** ページ切替ハンドラ */
    const handlePageChange = (page: number) => {
      currentPage.value = page;
      // スクロールを一番上に戻す
      scrollToTop();
    };

    /**
     * コンテンツリンク押下時
     */
    const handleContentsLinkClick = () => {
      // セッションストレージに現在ページを保存
      sessionStorage.setItem(
        AppConstants.CURRENT_PAGE_SESSION_NAME,
        currentPage.value.toString()
      );
    };

    /**
     * コンテンツ編集
     * コンテンツ登録画面に編集モードで遷移します
     * @param ctgyId - カテゴリID
     * @param ctsId - コンテンツID
     */
    const editContents = (ctgyId: string, ctsId: string) => {
      if (processingStore.isProcessing) {
        return;
      }
      processingStore.isProcessing = true;

      try {
        outputDebugLogs("カテゴリID: " + ctgyId);
        outputDebugLogs("コンテンツID: " + ctsId);

        // コンテンツ登録画面へ編集モードで遷移
        router.push({
          path: "/notification-reg",
          query: {
            categoryId: ctgyId,
            contentsId: ctsId,
            editMode: AppConstants.CONTENTS_EDIT_MODE_UPDATE,
          },
        });
      } finally {
        processingStore.isProcessing = false;
      }
    };

    /**
     * カテゴリIDに該当するデータを取得します。
     * @param categoryId = カテゴリID
     */
    const getNarrowCategoryData = (
      categoryId: string,
      categoryName: string
    ) => {
      narrowContentsListData.value = contentsListData.value.filter(
        (item) => item.categoryId === categoryId
      );

      selectedCategoryId.value = categoryId;

      // ページネーションの現在ページを1ページ目に
      currentPage.value = 1;

      // キーワードをサニタイジング
      const sanitizedKeyWord = trimKeyword(
        sanitizeInput(narrowKeyword.value, true)
      );

      if (sanitizedKeyWord) {
        dispKeyWord.value = "「" + sanitizedKeyWord + "」";
        dispTitle.value =
          "の検索結果:" + narrowContentsListData.value.length + "件";
      } else {
        dispKeyWord.value = categoryName;
        dispTitle.value = ":" + narrowContentsListData.value.length + "件";
      }

      isSerched.value = true;
    };

    //** 並び替え処理 */
    const sortedContentsListData = computed(() => {
      const data = [...narrowContentsListData.value]; // 元のデータをコピーして使用
      switch (sortOption.value) {
        case "new":
          // 新着順 掲載日：降順 コンテンツID：昇順
          return data.sort(
            (a, b) =>
              b.postPeriod.localeCompare(a.postPeriod) ||
              a.contentId.localeCompare(b.contentId)
          );
        case "category":
          // カテゴリ順 カテゴリID
          return data.sort(
            (a, b) =>
              a.categoryId.localeCompare(b.categoryId) ||
              b.postPeriod.localeCompare(a.postPeriod) ||
              a.contentId.localeCompare(b.contentId)
          );
        case "recommend":
        default:
          // おすすめ順
          return data.sort(
            (a, b) =>
              b.serchScore - a.serchScore ||
              b.postPeriod.localeCompare(a.postPeriod) ||
              a.contentId.localeCompare(b.contentId)
          );
      }
    });

    //** 並び替え条件を更新して、ページを最初のページにリセットします */
    const updateSortOption = (option: string) => {
      sortOption.value = option;
      currentPage.value = 1; // 並び替え時にページを最初にリセット
    };

    //** 現在の並び替え条件を表示 */
    const currentSortOptionLabel = computed(() => {
      switch (sortOption.value) {
        case "new":
          return "新着順";
        case "category":
          return "カテゴリ順";
        case "recommend":
        default:
          return "おすすめ順";
      }
    });

    return {
      errorMessage,
      apiErrorMessage,
      isInitError,
      uncheckAll,
      checkCategoryStatus,
      toggleCategory,
      isProcessing: processingStore.isProcessing,
      narrowSearch,
      groupedTags,
      narrowKeyword,
      categoryListData,
      getImageUrl,
      getContentsByCategory,
      downloadFiles,
      filteredCategoryListData,
      narrowContentsListData,
      isSerched,
      backInitDisp,
      dispTitle,
      dispKeyWord,
      currentPage,
      itemsPerPage,
      paginatedData,
      isKaunetAdmin,
      totalPages,
      handlePageChange,
      handleContentsLinkClick,
      editContents,
      getNarrowCategoryData,
      selectedCategoryId,
      currentSortOptionLabel,
      updateSortOption,
      isDataFetched,
      isLoading,
    };
  },
});
</script>
